<template>
  <div class="statement">
    <img
      src="../../../assets/statement.png"
      alt=""
    >
  </div>
</template>

<script>

export default {
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less">
.statement {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #fff;
  img {
    width: 991px;
  }
}
</style>
